module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan2-3-3dcfa9842d0ba3a3e5f40b18d714ac39.webp";